module.exports = __webpack_public_path__ + "static/Songela-ec68ed076f2b6f19079ab4497dab92af.jpg";